import { useContext } from "react";
import { CartContext } from "../providers/CartProvider";

/**
 * Hook wrapper for cart context
 */
export default function useShoppingCart() {
    return useContext(CartContext);
}
